import { render, staticRenderFns } from "./AddNotification.vue?vue&type=template&id=edf22d64&scoped=true&"
import script from "./AddNotification.vue?vue&type=script&lang=js&"
export * from "./AddNotification.vue?vue&type=script&lang=js&"
import style0 from "./AddNotification.vue?vue&type=style&index=0&id=edf22d64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf22d64",
  null
  
)

export default component.exports